import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  tcPrivacyPolicyCheckboxContainer: {
    fontSize: "0.75rem",
    textAlign: "left",
    color: theme.palette.events.textPrimary,
    "& a": {
      fontSize: "14px",
      color: theme.palette.events.bluePrimary,
    },
  },
}));
